import { KYMW1301Model } from '../kymw1301.model';
import { KYMW1301CatalogDataCsvModel } from '../vo/kymw1301-catalog-data-csv.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 企画書データ出力画面　企画書データを出力するサービス
 *
 * @export GetPlanCSVService
 * @class GetPlanCSVService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetPlanCSVService extends PlessJsonResponderSub<any> {

  /**
   * 処理に使用するModel
   *
   * @private
   * @type {KYMW1301Model}
   * @memberof GetPlanCSVService
   */
  private model: KYMW1301Model;

  /**
   * 処理に使用するVO
   *
   * @private
   * @type {KYMW1301CatalogDataCsvModel}
   * @memberof GetPlanCSVService
   */
  private vo: KYMW1301CatalogDataCsvModel;

  /**
   * API成功時後続処理
   *
   * @private
   * @type {Function}
   * @memberof GetPlanCSVService
   */
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetPlanCSVService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      search: {
        Rec: {
          parameter: {
            OrderCodeFrom: this.vo.orderCodeFrom,
            OrderCodeTo: this.vo.orderCodeTo,
            PCode: this.vo.pCode,
            MediumType: this.vo.mediumType,
            CoopCode: this.vo.coopCode,
            PageNumFrom: this.vo.pageNumFrom,
            PageNumTo: this.vo.pageNumTo,
            OrderNum: this.vo.orderNum,
            FeatureCode: this.vo.featureCode,
            MarkCode1: this.vo.markCode1,
            MarkCode2: this.vo.markCode2,
            MarkCode3: this.vo.markCode3,
            MarkCode4: this.vo.markCode4,
            MarkCode5: this.vo.markCode5,
            WPublishFlag: this.vo.wPublishFlag,
            MultiPublishFlag: this.vo.multiPublishFlag,
          },
          combination: this.vo.classificationsList.map(classCode => {
            return {
              parameter: {
                ClassCode: classCode
              }
            }
          })
        }
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @param vo
   * @param {Function} successFunc 成功時後続処理
   * @memberof GetPlanCSVService
   */
  execute(model: any, vo: any, successFunc: Function): void {
    this.model = <KYMW1301Model>model;
    this.vo = <KYMW1301CatalogDataCsvModel>vo;
    this.successFunc = successFunc;
    this.send('getPlanCSV', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetPlanCSVService
   */
  success(data: any): void {
    if (data !== null) {
      this.successFunc(data);
    }
  }
}
